import React from 'react'
import { formatDate } from '../../utils/api'

// The codes are Prism's OfferDeclineReason values (Prism spec 20261013). The
// labels are operator copy and can change here alone.
export const OFFER_DECLINE_REASON_LABELS = {
  price_too_low: 'Price too low',
  sold_elsewhere: 'Sold it somewhere else',
  keeping_it: 'Decided to keep it',
  only_valuation: 'Only wanted a valuation',
  paid_after_sending: 'Does not want to send before being paid',
  sending_hassle: 'Packing and sending is too much hassle',
  items_missed: 'Items were missed from the quote',
  wanted_cash: 'Wanted a cash price, not Commission Service',
  other: 'Something else',
}

// A code this build does not know still reads as words, never as nothing.
const reasonLabel = (code) => OFFER_DECLINE_REASON_LABELS[code] ?? String(code).replace(/_/g, ' ')

// The customer said "no for now" on the quote page. A decline does not move
// the stage, so a declined quote still reads Quote Sent, and this banner is
// the only place an operator sees it. `declines` is oldest first.
export default function OfferDeclineBanner({ declines, stage }) {
  if (!declines || declines.length === 0) return null
  const latest = declines[declines.length - 1]
  const reasons = latest.reasons ?? []
  return (
    <div role="status"
         style={{ background: 'var(--color-bg-secondary)', border: '1px solid var(--color-border)',
                  borderRadius: 8, padding: '10px 14px', marginBottom: 'var(--space-4)',
                  fontSize: '0.85rem', lineHeight: 1.5 }}>
      <div>
        <strong>Customer declined this offer</strong> on {formatDate(latest.declined_at)}
        {declines.length > 1 && (
          <span className="text-muted"> (Declined {declines.length} times. The latest is shown.)</span>
        )}
      </div>
      {reasons.length > 0 && <div>Reasons: {reasons.map(reasonLabel).join(', ')}</div>}
      {latest.note && <div>Note: “{latest.note}”</div>}
      {stage === 'quote_sent' && (
        <div className="text-muted">
          Reminder emails have stopped. Do not chase. The customer can still accept the offer.
        </div>
      )}
    </div>
  )
}
